import Error from '../model/Error';
import InvoiceRecipient from '../dto/InvoiceRecipient';
import axios from 'axios';

export default class InvoiceRecipientRepository {

    static findByChild(childId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/children/${childId}/invoice-recipients`, {  })
                .then(response => resolve(response.data.data.map(data => InvoiceRecipient.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

}
